import { render, staticRenderFns } from "./MessagesStatistics.vue?vue&type=template&id=5212228c"
import script from "./MessagesStatistics.vue?vue&type=script&lang=js"
export * from "./MessagesStatistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports